<template>
  <div>
    <b>xx首页</b>
  </div>
</template>

<script>
  export default {
    name: 'Dashboard',
    data() {
      return {}
    }
  }
</script>




// WEBPACK FOOTER //
// src/main/home/Dashboard.vue